<template>
    <div><template v-if="item[itemShowKey]">
            <el-button class="is-round" size="mini" @click="$emit('cancelAssignEdit', index, cancelType)">
                取消
            </el-button>
            <el-button class="is-round" type="primary" size="mini"
                @click="$emit('tryToStoreAssignHelper', { isSpace: isSpace })">
                儲存
            </el-button>
        </template></div>
</template>

<script>
export default {
    name: 'HelperSaveCancelBtn',
    components: {},
    mixins: [],
    props: {
        itemShowKey: {
            type: String,
            require: true,
            default: ''
        },
        index: {
            type: Number,
            require: true,
            default: -1
        },
        cancelType: {
            type: String,
            require: true,
            default: ''
        },
        isSpace: {
            type: Number,
            require: true,
            default: -1
        },
        item: {
            type: Object,
            require: true,
            default: () => { }
        }
    },
    data() {
        return {};
    },
    provide() { },
    inject: [],
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {},
};
</script>

<style lang="scss" module></style>
